export type CriterionStatus = 'success' | 'fail' | 'unset';

export interface UploadCriteriaInterface {
  title: string;
  status: CriterionStatus;
}

export const UPLOAD_COMPLETED_CRITERIA: UploadCriteriaInterface[] = [
  { title: 'photo_upload_criteria_1', status: 'success' },
  { title: 'photo_upload_criteria_2', status: 'success' },
  { title: 'photo_upload_criteria_3', status: 'success' },
];

export const UPLOAD_NOT_STARTED_CRITERIA: UploadCriteriaInterface[] = [
  { title: 'photo_upload_criteria_1', status: 'unset' },
  { title: 'photo_upload_criteria_2', status: 'unset' },
  { title: 'photo_upload_criteria_3', status: 'unset' },
];

export const UPLOAD_ERROR_CRITERIA: UploadCriteriaInterface[] = [
  { title: 'photo_upload_criteria_1', status: 'fail' },
  { title: 'photo_upload_criteria_2', status: 'fail' },
  { title: 'photo_upload_criteria_3', status: 'fail' },
];
